"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowUtils = void 0;
/** WindowUtils class. */
var WindowUtils = /** @class */ (function () {
    function WindowUtils() {
    }
    /**
     * open url in new window
     * @param url string
     */
    WindowUtils.openDataUrl = function (url) {
        var newWindow = window.open('', '_blank');
        if (newWindow != null) {
            newWindow.document.write("<iframe\n                    src=\"" + url + "\"\n                    frameborder=\"0\"\n                    style=\"border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;\"\n                    allowfullscreen></iframe>");
        }
    };
    return WindowUtils;
}());
exports.WindowUtils = WindowUtils;
//# sourceMappingURL=window.js.map